import BASE_DEV_HOST from 'common/config/api';

export const SCALAR_LOGO_URL = 'https://app.scalar.io/favicon.ico';

export const DEFAULT_MCP_CLIENT_ID = 'scalar-mcp-desktop';

export const MCP_SCOPE_PERMISSIONS = [
  'Read your portfolio companies and valuations',
  'Send information requests on your behalf',
  'Access documents you have permission to view',
];

export interface OAuthClientInfo {
  client_id: string;
  name: string;
  logo_url: string;
}

export async function fetchOAuthClientInfo(clientId: string): Promise<OAuthClientInfo> {
  const res = await fetch(
    `${BASE_DEV_HOST}/oauth/client?client_id=${encodeURIComponent(clientId)}`,
  );
  if (!res.ok) {
    throw new Error('Unknown application');
  }
  return (await res.json()) as OAuthClientInfo;
}
